function configureFetch(configuration) {
  const { fetch } = configuration;

  return (url, options) => {
    return fetch(url, options).catch(error => {
      throw error;
    });
  };
}

export default configureFetch;
